class BaseTransaction {
    type;
    action;
    kind;
    constructor(params) {
        this.action = params.action;
        this.type = params.type;
        this.kind = params.kind;
    }
    isEvm() {
        return this.type === 'evm';
    }
}
export default BaseTransaction;
